import React from "react";
import Carousel from "./carousel/Carousel";

export interface IOrganisation {
  img: string;
  title: string;
  description: string;
}

const Leaders: React.FC = () => {
  const organizationsData: IOrganisation[] = [
    {
      img: "/skill/carousel/nsdc.png",
      title: "NSDC: National Skill Development Corporation",
      description: "Driving skill development to align with industry needs.",
    },
    {
      img: "/skill/carousel/msde.png",
      title: "MSDE: Ministry of Skill Development and Entrepreneurship",
      description: "Empowering youth with skills for a brighter future.",
    },
    {
      img: "/skill/carousel/mord.png",
      title: "MORD: Ministry of Rural Development",
      description:
        "Transforming rural livelihoods through specialized training programs.",
    },
    {
      img: "/skill/carousel/moud.png",
      title: "MOUD: Ministry of Urban Development",
      description:
        "Enhancing urban communities with skill-based opportunities.",
    },
    // {
    //   img: "/skill/carousel/state-gmt.png",
    //   title: "State Governments",
    //   description:
    //     "Tailoring programs to address the unique needs of local populations.",
    // },
    {
      img: "/skill/carousel/mpbse.png",
      title: "MP Education Board:",
      description:
        " Empowering students with skill-driven learning initiatives.",
    },
    {
      img: "/skill/carousel/jkbose.png",
      title: "JKBOSE: Jammu & Kashmir Board of School Education",
      description:
        "Fostering academic excellence with skill-integrated learning.",
    },
    {
      img: "/skill/carousel/cgsrlm.png",
      title: "CGSRLM: Chhattisgarh State Rural Livelihoods Mission",
      description:
        "Empowering rural communities through sustainable skill development.",
    },
    {
      img: "/skill/carousel/jsdm.png",
      title: "JSDM: Jharkhand Skill Development Mission",
      description:
        "Bridging the gap between education and employment through skill training.",
    },
    {
      img: "/skill/carousel/mpsrlm.png",
      title: "MPSRLM: Madhya Pradesh State Rural Livelihoods Mission",
      description:
        "Enhancing rural livelihoods through skill development and entrepreneurship.",
    },
    {
      img: "/skill/carousel/psdm.png",
      title: "PSDM: Punjab Skill Development Mission",
      description:
        "Empowering youth with industry-relevant skills for a brighter future.",
    },
    {
      img: "/skill/carousel/upsrlm.png",
      title: "UPSRLM: Uttar Pradesh State Rural Livelihoods Mission",
      description:
        "Transforming rural livelihoods through skill development and self-reliance.",
    },
  ];

  return (
    <div>
      <div>
        <h3 className="max-w-4xl font-normal text-xl md:text-xl lg:text-3xl xl:text-5xl text-[#182152]">
          Collaborating with Leaders in Skill Development
        </h3>
      </div>
      <div className="flex flex-col md:flex-row gap-10 pt-5 lg:pt-7 xl:pt-12">
        <p className="md:max-w-[29rem] lg:text-xl xl:text-3xl xl:leading-tight">
          Our impactful initiatives are made possible through partnerships with
          esteemed government bodies and ministries. These collaborations enable
          us to bring skill development opportunities to every corner of the
          nation, ensuring inclusivity and quality.
        </p>
        <div className="flex flex-1 justify-center w-full">
          <Carousel slides={organizationsData} />
        </div>
      </div>
    </div>
  );
};

export default Leaders;
